module.exports = __webpack_public_path__ + "assets/icon-journey-call.1092b3b4.svg";